<template>
  <div>
    <!-- this was created as a separate component because it will probably be reused in a modal -->
    <!-- TODO: obviously, all the markup -->
    <div class="py-3 d-flex align-items-left">
      <b-avatar variant="warning" text="HH"  class="text-white mr-3"></b-avatar>
      <span>
        <h4 class="m-0">Autentificare B2B</h4>
        <p class="m-0 text-primary">Hello Hollidays</p>
      </span>
    </div>
    <hr class="my-3">
    <ValidationObserver ref="loginForm" slim>
      <b-form @submit.prevent="login" class="clearfix mb-3">
        <ValidationProvider
            name="ID companie"
            :rules="{ required: true }"
            v-slot="vContext"
          >
          <b-form-group
            label="ID companie:"
            label-class="font-weight-bold pt-0"
            label-for="agency"
            >
            <b-input-group>
              <b-input-group-prepend is-text class="login-form-prepend">
                <b-icon icon="house-fill" font-scale="0.8"></b-icon>
              </b-input-group-prepend>
              <b-form-input
              type="text"
              name="ID companie"
              id="agency"
              v-model="credentials.client"
              placeholder="id companie"
              :state="getValidationState(vContext)"
              size="sm"
              aria-describedby="agency"/>
              <b-form-invalid-feedback id="agency">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          name="Nume utilizator"
          :rules="{required: true}"
          v-slot="vContext"
        >
          <b-form-group
            label="Nume utilizator:"
            label-class="font-weight-bold pt-0"
            label-for="numeAgent"
          >
            <b-input-group>
              <b-input-group-prepend is-text class="login-form-prepend">
                <b-icon icon="person-square" font-scale="0.8"></b-icon>
              </b-input-group-prepend>
              <b-form-input
              type="text"
              name="numeAgent"
              id="numeAgent"
              v-model="credentials.username"
              placeholder="nume utilizator"
              size="sm"
              :state="getValidationState(vContext)"
              aria-describedby="agentName" />
              <b-form-invalid-feedback id="agentName">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          name="Parola"
          :rules="{required: true}"
          v-slot="vContext"
        >
          <b-form-group
            label="Parola:"
            label-class="font-weight-bold pt-0"
            label-for="password">
            <b-input-group>
              <b-input-group-prepend is-text class="login-form-prepend">
                <b-icon icon="shield-lock-fill" font-scale="0.8"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                type="password"
                name="password"
                id="password"
                v-model="credentials.password"
                placeholder="parola"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="password" />
              <b-form-invalid-feedback id="password">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </ValidationProvider>
        <hr class="my-4">
        <b-button type="submit" variant="outline-primary" class="float-right btn-sm">
          <b-icon icon="unlock-fill" class="mr-2"></b-icon>
          <b>LOGIN</b>
        </b-button>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import validation from 'b2b-common/mixins/validation'
import toast from 'b2b-common/mixins/toast'

export default {
  name: 'Login',
  mixins: [validation, toast],
  data () {
    return {
      credentials: {
        client: '',
        username: '',
        password: ''
      }
    }
  },
  methods: {
    login () {
      this.$refs.loginForm.validate().then(success => {
        if (!success) {
          this.addToast({ title: 'Formular invalid', message: 'Va rugam completati toate campurile obligatorii!', variant: 'danger' })
        } else {
          this.$emit('login', this.credentials)
        }
      })
    }
  }
}
</script>

<style  scoped>
a.link{
  cursor: pointer;
  color:blue;
}
a.link:hover{
  text-decoration: underline!important;
}
</style>
